module.exports = __webpack_public_path__ + "static/market-index-treemap-a9fbfd72e9e913baf224953aeb3f3b2c.png";